<template>
    <b-overlay :show="showLoader">
        <b-card>
            <h2 style="font-weight: bold;">Izpolnite podatke o novici</h2>
            <validation-observer ref="validate">
                <b-form class="form mt-1">
                    <News ref="news" v-model="object" type=""/>
                    <b-form-group class="text-right">
                        <b-button variant="secondary" @click.prevent="validationForm">ODDAJ NOVICO</b-button>
                    </b-form-group>
                </b-form>
            </validation-observer>
        </b-card>
    </b-overlay>
</template>

<script>
    import { ValidationObserver } from 'vee-validate'
    import News from '../../Components/News'
    import {BButton, BCard, BForm, BFormGroup, BOverlay} from 'bootstrap-vue'
    export default {
        components: {
            ValidationObserver,
            News,
            BOverlay,
            BCard,
            BForm,
            BFormGroup,
            BButton
        },

        data() {
            return {
                object: {
                    title:'',
                    author_id:0,
                    date_added:'',
                    content:'',
                    additional_photos: [],
                    main_photo: '',
                    active: true
                },
                showLoader: false
            }
        },
        methods: {
            async validationForm() {
                this.$refs.validate.validate().then(async(success) => {
                    if (success) {
                        await this.addNews()
                    }
                })

            },
            async addNews() {
                this.showLoader = true

                try {
                    const isImageUploadSuccessfull = await this.$refs.news.$refs.imageSelector.UploadImagesToAPI()
                    if (!isImageUploadSuccessfull) {
                        this.$printError('Prišlo je do napake pri nalaganju slik.')
                        return
                    }
                    if (this.object.main_photo === '') {
                        this.$printWarning('Potrebno je dodati vsaj eno fotografijo')
                        return
                    }

                    this.object.author_id = this.$store.state.user.userData.id
                    this.object.date_added = new Date()
                  
                    await this.$http.put('/api/management/v1/news/', this.object)
                    this.$printSuccess('Novica je dodana')
                    setTimeout(() => {
                        this.$router.push({name: 'admin-news-list'})
                    }, 1000)
                } catch (error) {
                    this.$printError(error.response.data)
                } finally {
                    this.showLoader = false
                }
            }
        }
    }
</script>